import { createVNode as c, mergeProps as v, isVNode as I } from "vue";
import { warning as h, useInsertStyles as N, svgBaseProps as P } from "../utils.js";
function j(t) {
  return typeof t == "function" || Object.prototype.toString.call(t) === "[object Object]" && !I(t);
}
const p = (t, S) => {
  const {
    attrs: x,
    slots: r
  } = S, {
    class: d,
    component: s,
    viewBox: o,
    spin: u,
    rotate: i,
    tabindex: B,
    onClick: f,
    ...g
  } = {
    ...t,
    ...x
  }, e = r.default && r.default(), m = e && e.length, a = r.component;
  h(Boolean(s || m || a), "Should have `component` prop/slot or `children`."), N();
  const b = {
    anticon: !0,
    [d]: d
  }, y = {
    "anticon-spin": u === "" || !!u
  }, w = i ? {
    msTransform: `rotate(${i}deg)`,
    transform: `rotate(${i}deg)`
  } : void 0, n = {
    ...P,
    viewBox: o,
    class: y,
    style: w
  };
  o || delete n.viewBox;
  const C = () => s ? c(s, n, j(e) ? e : {
    default: () => [e]
  }) : a ? a(n) : m ? (h(Boolean(o) || e.length === 1 && e[0] && e[0].type === "use", "Make sure that you provide correct `viewBox` prop (default `0 0 1024 1024`) to the icon."), c("svg", v(n, {
    viewBox: o
  }), [e])) : null;
  let l = B;
  return l === void 0 && f && (l = -1, g.tabindex = l), c("span", v({
    role: "img"
  }, g, {
    onClick: f,
    class: b
  }), [C()]);
};
p.props = {
  spin: Boolean,
  rotate: Number,
  viewBox: String,
  ariaLabel: String
};
p.inheritAttrs = !1;
p.displayName = "Icon";
export {
  p as default
};
